import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import { map } from 'lodash';
import './index.less';
import M from '../../assets/svgImg/M.svg';
import A from '../../assets/svgImg/A.svg';
import X from '../../assets/svgImg/X.svg';
import Img from '../../assets/img/whyImg.png';

class Why extends React.PureComponent {
  render() {
    const { Title, Paragraph } = Typography;
    const dataMax = [
      {
        title: 'Reduce',
        icon: M,
        src: 'Reduce power losses on transmission and distribution lines.',
      },
      {
        title: 'Prevent',
        icon: A,
        src: 'Prevent unscheduled downtime.',
      },
      {
        title: 'Improve',
        icon: X,
        src: 'Improve protection against electrical faults, arcing, fire.',
      },
    ];

    return (
      <Row align="middle" justify="center" className="why-block">
        <Col id="goWhy" xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="why-header">
          <Typography>
            <Title className="title" level={2}>
              Why?
            </Title>
          </Typography>
          <div>
            <Paragraph>Why You Need TransforMAX</Paragraph>
          </div>
        </Col>
        <Col className="MAX" xxl={22} xl={22} lg={22} md={22} sm={22} xs={22}>
          <div className="card">
            {map(dataMax, data => (
              <Typography className="max-card">
                <Title level={4}>{data.title}</Title>
                <img src={data.icon} />
                <span>
                  <p>{data.src}</p>
                </span>
              </Typography>
            ))}
          </div>
          <Divider className="divider" />
        </Col>
        <div className="whyImg">
          <img src={Img} />
        </div>
      </Row>
    );
  }
}

export default Why;
